/**
 * Workflow helper
 */
class FileslotHelper {
  __getFilesCountBySlotCode (object, slotCode) {
    let slot = this.__getSlotByCode(object, slotCode)
    let result = 0
    if (slot && typeof object === 'object' && object.hasOwnProperty('modelFiles')) {
      object.modelFiles.forEach(modelFile => {
        if (modelFile.slot && modelFile.slot.code === slot.code) {
          result++
        }
      })
    }
    return result
  }

  __getFilesBySlotCode (object, slotCode) {
    let slot = this.__getSlotByCode(object, slotCode)
    let result = []
    if (slot && typeof object === 'object' && object.hasOwnProperty('modelFiles')) {
      for (let i in object.modelFiles) {
        if (object.modelFiles[i].hasOwnProperty('slot') && object.modelFiles[i].slot.code === slot.code) {
          result.push(object.modelFiles[i])
        }
      }
    }
    return result
  }

  __getSlotByCode (object, slotCode) {
    if (this.hasSlots(object)) {
      for (let i in object.fileSlots) {
        if (object.fileSlots[i].code === slotCode) {
          return object.fileSlots[i]
        }
      }
    }
    return null
  }

  __getSlotsByCode (object, codes) {
    let result = []
    if (Array.isArray(codes)) {
      if (this.hasSlots(object)) {
        for (let i in codes) {
          let slot = this.__getSlotByCode(object, codes[i])
          if (slot) {
            result.push(slot)
          }
        }
      }
    }
    return result
  }

  hasSlots (object) {
    return typeof object === 'object' && object.hasOwnProperty('fileSlots') && Array.isArray(object.fileSlots)
  }

  slotFilled (object, slotCode) {
    return this.__getFilesCountBySlotCode(object, slotCode) > 0
  }

  getSlotWorkflowState (object, slotCode) {
    let slot = this.__getSlotByCode(object, slotCode)
    if (slot && slot.hasOwnProperty('workflowState')) {
      return slot.workflowState
    }
    return null
  }
}

const fileslotHelper = new FileslotHelper()
export default fileslotHelper
